export const fuelTypes: { [unit: string]: string } = {
  U: 'Benzina',
  D: 'Diesel'
};
